var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExit = function SvgExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-.6%",
    y: "-1.1%",
    width: "101.5%",
    height: "102%",
    filterUnits: "objectBoundingBox",
    id: "exit_svg__a"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    "in": "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    "in": "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0",
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-6.2%",
    y: "-6.2%",
    width: "112.5%",
    height: "112.5%",
    filterUnits: "objectBoundingBox",
    id: "exit_svg__d"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0",
    "in": "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-25%",
    y: "-5%",
    width: "200%",
    height: "120%",
    filterUnits: "objectBoundingBox",
    id: "exit_svg__e"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0",
    "in": "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-12.5%",
    y: "-12.5%",
    width: "125%",
    height: "125%",
    filterUnits: "objectBoundingBox",
    id: "exit_svg__h"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    "in": "SourceAlpha",
    result: "shadowSpreadInner1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    "in": "shadowSpreadInner1",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    "in": "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0",
    "in": "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12 0h648c6.627 0 12 5.373 12 12v641H0V12C0 5.373 5.373 0 12 0Z",
    id: "exit_svg__b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 7v6H7V7h2Zm0-4v2H7V3h2Z",
    id: "exit_svg__f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "exit_svg__c",
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "exit_svg__g",
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A0C4C9",
    d: "M-771-415H253v697H-771z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE000",
    d: "M-419-415h672v697h-672z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-419 -371)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#exit_svg__a)",
    xlinkHref: "#exit_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#exit_svg__b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#9ABDC2",
    xlinkHref: "#exit_svg__c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#exit_svg__d)",
    xlinkHref: "#exit_svg__c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#exit_svg__e)",
    xlinkHref: "#exit_svg__f"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#exit_svg__f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-252 -8)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#9ABDC2",
    width: 268,
    height: 119,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(248 4)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#exit_svg__g"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#exit_svg__h)",
    xlinkHref: "#exit_svg__g"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m253.707 8.293 2.297 2.297 2.298-2.297a1 1 0 1 1 1.414 1.414l-2.297 2.297 2.297 2.298a1 1 0 1 1-1.414 1.414l-2.298-2.297-2.297 2.297a1 1 0 0 1-1.414-1.414l2.297-2.298-2.297-2.297a1 1 0 0 1 1.414-1.414Z",
    fill: "#9ABDC2"
  })))));
};
export default SvgExit;